var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-row',{attrs:{"type":"flex"}},[_c('a-col',{attrs:{"span":_vm.iconSize}}),_vm._v(" "),_c('a-col',{attrs:{"span":24 - _vm.iconSize}},[_c('a-divider',{style:({ margin: '10px 0px' })})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }